



function showModalFastSignup() {


    if( jQuery(".js-register-modal").length ){

        setTimeout(function(){
            $('.js-register-modal').modal('show');
        }, 2000)
    }
};





export {showModalFastSignup}
